<app-type-delais id="step10" [uid]="getUid()" [parentForm]="parentForm"
[disabled]="disabled"
 [delais]="initial.delais"></app-type-delais>


